import React from 'react'
import Link from './link'

const linkChildren = (children, defaults, isInternal) => {
  return children

  return React.Children.map(children, (child) => {
    return linkComponent(child, defaults, isInternal)
  })
}

export const linkComponent = (component, defaults, isInternal) => {
  if (!isInternal) {
    return component
  }

  return component

  return (
    <Link to={defaults.nextPageId}>
      {component}
    </Link>
  )
}

export default linkChildren
